module.exports = "/_next/static/images/broadband-labels-info-19cdb9360d66752ce3f15721b15d7186.webp";